// src/pages/CheckoutSuccessPage.js
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

export default function CheckoutSuccessPage() {
useEffect(() => {
  const token = localStorage.getItem('clairifi_token') || '';
  let tries = 0;
  const t = setInterval(async () => {
    try {
      const r = await fetch('/api/auth/me', { headers: { Authorization: `Bearer ${token}` }});
      const me = await r.json();
      const active = (me?.plan === 'core') || (me?.subscription_status === 'active') || (me?.subscription_status === 'trialing');
      if (active) {
        clearInterval(t);
        window.location.replace('/dashboard');
      }
    } catch (_) { /* ignore */ }
    if (++tries > 20) { clearInterval(t); window.location.replace('/onboarding/tour'); } // ~24s fallback
  }, 1200);
  return () => clearInterval(t);
}, []);


  return (
    <div className="legal-wrap">
      <h1>Payment successful</h1>
      <p>Your Clairifi Core subscription is active. You now have full access (3 uploads/month).</p>
      <p><Link className="btn" to="/dashboard">Go to Dashboard</Link></p>
    </div>
  );
}
